/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  Constants for Walkscore module
 */

export const RECEIVE_WALKSCORE = '@@nzr/walkscore/RECEIVE_WALKSCORE' as const
